import React from 'react';
import { Navigate } from 'react-router';
import Base from './Base';
import { Header } from './Header';
import { Footer } from './Footer';
import Receipt from "./Receipt";
import Document from "./Document";
import GridConfig from "./GridConfig";

export default class Receipts extends Base {
    constructor(props) {
        super(props);
        this.state = {
            controllerName: 'receipt',
            type: props.Type,
            data: null,
            loading: true,
            configName: 'receipts_grid',
            moduleName: 'دریافت و پرداختها',
            filters: {
                type: props.Type
            }
        };
        this.keyDownFunction = this.keyDownFunction.bind(this);
    }
    componentWillUnmount() {
        this.removeKeyDown();
    }
    componentDidMount() {
        this.refreshData();
    }
    componentWillReceiveProps(props) {
        if (props.Type == this.state.filters.type) return;
        this.state.filters.type = props.Type;
        this.refreshData();
    }
    onEdit(id) {
        this.removeKeyDown();
        this.showComponents({ component: <Receipt Caller={this} Id={id} /> });
    }
    onAdd(type) {
        this.removeKeyDown();
        this.showComponents({ component: <Receipt Type={type} Caller={this} /> });
    }
    showDocument(id) {
        this.showComponents({ component: <Document Caller={this} Id={id} /> });
    }
    onGridConfig() {
        this.showComponents({ component: <GridConfig Caller={this} Config={this.getGridConfig()} /> });
    }
    getDefaultConfig() {
        return {
            name: this.state.configName,
            fields: [
                { field: "description", caption: "شرح", show: true },
                { field: "total", caption: "مبلغ", show: true },
                { field: "dateString", caption: "تاریخ", show: true },
                { field: "documentNumber", caption: "شماره سند", show: true },
                { field: "factorNumber", caption: "شماره فاکتور", show: true },
                { field: "typeString", caption: "نوع", show: true },
                { field: "moeinCode", caption: "کدمعین", show: false },
                { field: "tafsilCode", caption: "کدتفصیل", show: false },
                { field: "editDateString", caption: "تاریخ ثبت", show: false },
                { field: "createDateString", caption: "تاریخ بروزرسانی", show: false }
            ]
        }
    }
    getColumns() {
        var config = this.getGridConfig();
        var t = [];
        config.fields.forEach(f => {
            if (f.field == 'description' && f.show) t.push({ field: f.field, headerName: f.caption, cellRenderer: (props) => { return <a className="text-primary txt-bold hand" onClick={e => this.onEdit(props.data.id)}>{props.data.description}</a> } });
            if (f.field == 'total' && f.show) t.push({ field: f.field, headerName: f.caption, cellDataType: 'number', cellRenderer: (props) => { return this.money(props.data.total) } });
            if (f.field == 'dateString' && f.show) t.push({ field: f.field, headerName: f.caption });
            if (f.field == 'documentNumber' && f.show) t.push({ field: f.field, headerName: f.caption, cellDataType: 'number' });
            if (f.field == 'factorNumber' && f.show) t.push({ field: f.field, headerName: f.caption, cellDataType: 'number' });
            if (f.field == 'typeString' && f.show) t.push({ field: f.field, headerName: f.caption });
            if (f.field == 'moeinCode' && f.show) t.push({ field: f.field, headerName: f.caption, cellDataType: 'number' });
            if (f.field == 'tafsilCode' && f.show) t.push({ field: f.field, headerName: f.caption, cellDataType: 'number' });
            if (f.field == 'editDateString' && f.show) t.push({ field: f.field, headerName: f.caption });
            if (f.field == 'createDateString' && f.show) t.push({ field: f.field, headerName: f.caption });
        });
        return t;
    }
    renderForm() {
        return <div className="container">
            <div className="row mr-b-10">
                <div className="col-md-12">
                    <a className="btn btn-no-frame btn-smoke btn-sm iransans" onClick={e => this.onAdd(1)} title="جدید">
                        <span className="fa fa-plus"></span> دریافت جدید
                    </a>
                    <a className="btn btn-no-frame btn-smoke btn-sm iransans" onClick={e => this.onAdd(2)} title="جدید">
                        <span className="fa fa-plus"></span> پرداخت جدید
                    </a>
                    <a className="btn btn-no-frame btn-smoke btn-sm pull-left" onClick={e => this.onPrint('فهرست ' + this.state.moduleName)} title="چاپ">
                        <span className="fa fa-print"></span>
                    </a>
                    <a className="btn btn-no-frame btn-smoke btn-sm pull-left" onClick={e => this.onPdf('فهرست ' + this.state.moduleName)} title="پی دی اف">
                        <span className="fa fa-file-pdf-o"></span>
                    </a>
                    <a className="btn btn-no-frame btn-smoke btn-sm pull-left" onClick={e => this.onExcel('فهرست ' + this.state.moduleName)} title="اکسل">
                        <span className="fa fa-file-excel-o"></span>
                    </a>
                    <a className="btn btn-no-frame btn-smoke btn-sm pull-left" onClick={e => this.onRemove()} title="حذف">
                        <span className="fa fa-trash"></span>
                    </a>
                    {/*<a className="btn btn-no-frame btn-smoke btn-sm pull-left" onClick={e => this.onGridConfig()} title="تنظیمات نمایش">*/}
                    {/*    <span className="fa fa-cog"></span>*/}
                    {/*</a>*/}
                </div>
            </div>
            {this.renderAgGrid({
                columnDefs: this.getColumns()
            })}
        </div>
    }
    render() {
        if (!this.isBlank(this.state.redirect)) return <Navigate to={this.state.redirect} />

        let contents = this.state.loading ? this.renderLoading() :
            [
                this.state.lockScreen === 1 && this.lockScreen(),
                this.getGlobalContainer(),
                <Header data={this.state.data} />,
                this.renderForm(),
                this.renderPopupComponent(),
                <Footer />
            ];
        return contents;
    }
}